export default "__VITE_ASSET__2d1b2d2d__"